import { FC, Fragment } from 'react'

import { AddressMapContextProvider } from 'components/common/AdressMap'
import { NewPropertyController } from './NewPropertyController.controller'
import { NewPropertyProvider } from './NewProperty.context'
import { PageTransition } from 'utils/animations'
import { PurchaseFlowRealEstatePropertyContextProvider } from '../PurchaseFlow/_main/contexts'

export const NewProperty: FC = () => {
  return (
    <Fragment>

      <AddressMapContextProvider>
        <PurchaseFlowRealEstatePropertyContextProvider>
          <NewPropertyProvider>
            <PageTransition>
              <NewPropertyController />
            </PageTransition>
          </NewPropertyProvider>
        </PurchaseFlowRealEstatePropertyContextProvider>
      </AddressMapContextProvider>

    </Fragment>
  )
}
